import {
    GET_SERVICE_REQUEST,
    GET_SERVICE_REQUEST_SUCCESS,
    GET_SERVICE_REQUEST_FAILURE,
    SERVICE_REQUEST_DETAILS,
    SERVICE_REQUEST_DETAILS_SUCCESS,
    SERVICE_REQUEST_DETAILS_FAILURE,
    DOWNLOAD_SERVICE_REQUEST,
    DOWNLOAD_SERVICE_REQUEST_SUCCESS,
    DOWNLOAD_SERVICE_REQUEST_FAILURE
} from "../Constants";

const init = {
    data: {},
    details_data: {},
    download_data : {}
};

const ServiceRequestReducer = (state = init, action) => {
    switch (action.type) {
        case GET_SERVICE_REQUEST:
            return { ...state, loading: true };
        case GET_SERVICE_REQUEST_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case GET_SERVICE_REQUEST_FAILURE:
            return { ...state, loading: false, data: action.payload };
        case SERVICE_REQUEST_DETAILS:
            return { ...state, loading: true };
        case SERVICE_REQUEST_DETAILS_SUCCESS:
            return { ...state, loading: false, details_data: action.payload };
        case SERVICE_REQUEST_DETAILS_FAILURE:
            return { ...state, loading: false, details_data: action.payload };
        case DOWNLOAD_SERVICE_REQUEST:
            return { ...state, loading: true};
        case DOWNLOAD_SERVICE_REQUEST_SUCCESS:
            return { ...state, loading: true, download_data : action.payload};
        case DOWNLOAD_SERVICE_REQUEST_FAILURE:
            return { ...state, loading: true, download_data : action.payload};
        default:
            return state;
    }
};

export default ServiceRequestReducer;